// list of all store actions
import Vue from 'vue'

export const Actions = {
  // auth
  AUTH_INIT: 'authInit',
  AUTH_LOGIN: 'authLogin',
  AUTH_LOGOUT: 'authLogout',
  // app
  APP_INIT: 'appInit',
  APP_DESTROY: 'appDestroy',
  APP_SET_CURRENT_TEAM: 'setCurrentTeam',
  APP_FETCH_TEAMS: 'appFetchTeams',
  APP_FETCH_LAYOUTS: 'appFetchLayouts',
  // alert
  ALERT: 'alertSetAlert',
  ALERT_TOGGLE_VISIBLE: 'alertToggleVisible',
  // variables
  VARIABLES_FETCH_ALL: 'variablesFetchAll'
}

declare module 'vue/types/vue' {
  interface Vue {
    $storeActions: typeof Actions;
  }
}

// noinspection JSUnusedGlobalSymbols
Vue.prototype.$storeActions = Actions
